import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

/**
 * Display a `<label>` with styling.
 */

@Component({
  selector: 'z-label',
  templateUrl: './label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelComponent {
  /**
   * Unique identifier for this label. This should match the ID of the control that this label is associated with.
   */
  @Input() id: string;

  /**
   * Text used for this label. This value should come pre-translated.
   */
  @Input() text: string;

  /**
   * When true the label will be shown with an invalid state class applied
   */
  @Input() invalid: boolean = false;

  /**
   * Object containing CSS styles for this component
   */
  @Input() style: Record<string, any>;

  /**
   * String containing classes to apply on this component
   */
  @Input() styleClass: string;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  update() {
    this.changeDetectorRef.detectChanges();
  }
}
